/* SKORE — Driver tip (v2). Pairs with snippets/skore-tip.liquid.
   Loaded once from layout/theme.liquid. Uses event delegation so it keeps
   working after Dawn re-renders the cart drawer. */
(function () {
  if (window.__skoreTip) return;
  window.__skoreTip = true;

  var CHOSEN_KEY = 'skore-tip-chosen'; // set once the shopper picks, or once we pre-select
  var busy = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function markChosen() { try { sessionStorage.setItem(CHOSEN_KEY, '1'); } catch (e) {} }
  function wasChosen() { try { return sessionStorage.getItem(CHOSEN_KEY) === '1'; } catch (e) { return false; } }

  // "100:4711,200:4712" -> { 100: '4711', 200: '4712' }  (price in cents -> variant id)
  function variants(el) {
    var map = {};
    (el.getAttribute('data-variants') || '').split(',').forEach(function (pair) {
      var p = pair.split(':');
      if (p.length === 2) map[parseInt(p[0], 10)] = p[1];
    });
    return map;
  }

  // Zero out every tip variant, then add the chosen amount.
  // Exact variant if one exists ($3 -> "$3" variant), otherwise $1 x N for custom amounts.
  function buildUpdates(el, dollars) {
    var map = variants(el);
    var updates = {};
    Object.keys(map).forEach(function (cents) { updates[map[cents]] = 0; });
    if (dollars > 0) {
      var exact = map[dollars * 100];
      if (exact) updates[exact] = 1;
      else if (map[100]) updates[map[100]] = dollars;
    }
    return updates;
  }

  function drawerOf(el) {
    var d = el.closest('cart-drawer');
    return d && typeof d.renderContents === 'function' ? d : null;
  }

  function setTip(el, dollars) {
    if (busy) return;
    busy = true;
    el.classList.add('is-loading');
    var drawer = drawerOf(el);
    var body = { updates: buildUpdates(el, dollars) };
    if (drawer) {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    }
    fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart update ' + r.status);
        return r.json();
      })
      .then(function (state) {
        if (drawer && state.sections) drawer.renderContents(state);
        else window.location.reload(); // cart page: simplest correct refresh
      })
      .catch(function (err) {
        console.error('[skore-tip]', err);
        el.classList.remove('is-loading');
      })
      .then(function () { busy = false; });
  }

  function isShowing(el) {
    if (el.hasAttribute('hidden') && el.getAttribute('data-orphan') !== 'true') return false;
    var drawer = el.closest('cart-drawer');
    if (drawer) return drawer.classList.contains('active');
    return true;
  }

  // Runs whenever tip markup appears or the drawer opens.
  function check(el) {
    if (el.__skoreChecked || !isShowing(el)) return;
    el.__skoreChecked = true;
    var tip = parseInt(el.getAttribute('data-tip'), 10) || 0;

    // Cart has nothing but a tip: remove it.
    if (el.getAttribute('data-orphan') === 'true') {
      if (tip > 0) setTip(el, 0);
      return;
    }
    // Pre-select once per visit, only if the shopper hasn't chosen and there's no tip yet.
    var preset = parseInt(el.getAttribute('data-preset'), 10) || 0;
    if (preset > 0 && tip === 0 && !wasChosen()) {
      markChosen();
      setTip(el, preset);
    }
  }

  var queued = false;
  function scan() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      document.querySelectorAll('[data-skore-tip]').forEach(check);
    });
  }

  function applyCustom(el) {
    var input = el.querySelector('.skore-tip__custom input');
    var val = parseInt(input && input.value, 10);
    if (isNaN(val) || val < 1) { if (input) input.focus(); return; }
    if (val > 50) val = 50;
    markChosen();
    setTip(el, val);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var el = t.closest('[data-skore-tip]');
    if (!el) return;

    var amtBtn = t.closest('[data-amt]');
    if (amtBtn) {
      e.preventDefault();
      markChosen();
      var dollars = parseInt(amtBtn.getAttribute('data-amt'), 10) || 0;
      var current = parseInt(el.getAttribute('data-tip'), 10) || 0;
      if (dollars * 100 !== current) setTip(el, dollars);
      return;
    }
    var other = t.closest('[data-custom]');
    if (other) {
      e.preventDefault();
      var box = el.querySelector('.skore-tip__custom');
      box.hidden = !box.hidden;
      other.setAttribute('aria-expanded', String(!box.hidden));
      if (!box.hidden) box.querySelector('input').focus();
      return;
    }
    if (t.closest('[data-custom-apply]')) {
      e.preventDefault();
      applyCustom(el);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.closest) return;
    var box = e.target.closest('.skore-tip__custom');
    if (box) {
      e.preventDefault();
      applyCustom(box.closest('[data-skore-tip]'));
    }
  });

  function start() {
    scan();
    new MutationObserver(scan).observe(document.body, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['class']
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
